import { render, staticRenderFns } from "./JBProposalContentsFireRate.vue?vue&type=template&id=62d300ac"
import script from "./JBProposalContentsFireRate.vue?vue&type=script&lang=js"
export * from "./JBProposalContentsFireRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports